import type { ReactNode } from 'react';
import { Button } from './Button';

export function EmptyState({ title = 'Пока пусто', text }: { title?: string; text?: ReactNode }) {
  return (
    <div className="state" data-state="empty">
      <div className="state__title">{title}</div>
      {text !== undefined && <div className="state__text">{text}</div>}
    </div>
  );
}

/** Скелет загрузки; количество строк ~ будущему контенту. */
export function LoadingState({ lines = 4 }: { lines?: number }) {
  return (
    <div className="skeleton" data-state="loading" aria-busy="true" aria-label="Загрузка">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="skeleton__line" style={{ width: `${88 - i * 9}%` }} />
      ))}
    </div>
  );
}

export function ErrorState({
  title = 'Не удалось загрузить данные',
  text,
  onRetry,
}: {
  title?: string;
  text?: ReactNode;
  onRetry?: () => void;
}) {
  return (
    <div className="state" data-state="error" role="alert">
      <div className="state__title">{title}</div>
      {text !== undefined && <div className="state__text">{text}</div>}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  );
}

export function ForbiddenState({ text }: { text?: ReactNode }) {
  return (
    <div className="state" data-state="forbidden">
      <div className="state__title">Недостаточно прав</div>
      <div className="state__text">
        {text ?? 'У вашей роли нет доступа к этому разделу. Обратитесь к администратору.'}
      </div>
    </div>
  );
}

/** version_conflict: объект изменён параллельно — предложить перечитать. */
export function ConflictState({ onReload }: { onReload?: () => void }) {
  return (
    <div className="state" data-state="conflict" role="alert">
      <div className="state__title">Объект изменён другим пользователем</div>
      <div className="state__text">
        Данные на экране устарели. Обновите объект и повторите действие — несохранённые изменения
        нужно будет внести заново.
      </div>
      {onReload && (
        <Button variant="secondary" onClick={onReload}>
          Обновить объект
        </Button>
      )}
    </div>
  );
}
